import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enables feature that allows sub-users to view & interact with Faire Pay.
 * See https://fairewholesale.atlassian.net/browse/FD-282814.
 */
export const FAIRE_PAY_MULTI_USER_MVP_250813 =
  'FAIRE_PAY_MULTI_USER_MVP_250813' as SettingConst<
    'FAIRE_PAY_MULTI_USER_MVP_250813',
    boolean,
    'RETAILER'
  >;
